import { LocalDate } from 'js-joda';
import { Query } from 'components/reporting';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { dashboard } from 'types';
import { map } from 'es-toolkit/compat';
import { toInstant } from '@tock/shared/utils/time';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { ReportQueries } = protos;

/*
 * Request reports based on the input series.
 */
export function fetchReports(series: { [id: string]: Query }, timeZone: string): ApiAction {
  const query: dashboard.IReportQuery[] = map(series, (request, key) => {
    return {
      reportName: key,
      dimension: request.dimensions.map((dimensionConfig) => dimensionConfig.dimension),
      metric: request.metrics.map((metricConfig) => metricConfig.metric),
      filter: request.filter,
      timeBuckets: {
        startInstantMs: toInstant(request.start, timeZone).toEpochMilli(),
        endInstantMs: toInstant(request.end, timeZone).toEpochMilli(),
        bucket: request.bucketing,
        timeZone,
      },
    };
  });

  const requestProto = ReportQueries.fromObject({
    query,
  });

  return {
    TockApi: {
      postProto: '/admin/reporting',
      type: SharedAppConstants.HUB_LANDING_FETCH_REPORTS,
      request: requestProto,
      discardOldRequests: true,
      onError: '', // Ignore reporting errors.
    },
  };
}

export const fetchDailyCoverSummary = (date: LocalDate): ApiAction => ({
  TockApi: {
    getListProto: `/admin/calendar/covers-summary?date=${date.toString()}`,
    type: AppConstants.HUB_LANDING_FETCH_DAILY_COVERS,
  },
});

export const fetchDailyLargeParties = (date: LocalDate): ApiAction => ({
  TockApi: {
    getListProto: `/admin/calendar/large-parties-summary?date=${date.toString()}`,
    type: AppConstants.HUB_LANDING_FETCH_DAILY_LARGE_PARTIES,
  },
});
